import {
  SearchButtonInside,
  SearchCharacterCount,
  SearchControlsAnchor,
  SearchRow,
} from './styled';
import { Input, Icon } from 'components/common';
import Tooltip from 'components/common/Tooltip';
import { colours } from 'utils/theme';

export const NLP_STAGE_ONE_MAX_QUERY_CHARS = 500;

export const NLPExpandingSearchInput = ({
  value = '',
  onChange,
  loading,
  onSearchButtonClick,
  disabled = false,
  placeholder = 'Search by name, topic, or keyword...',
}) => {
  const inputRightPadding = 180;
  const length = value.length;
  const overLimit = length > NLP_STAGE_ONE_MAX_QUERY_CHARS;
  const showCounter = length > 0;
  const isDisabled = loading || disabled;
  const isSearchEnabled =
    value.trim().length > 0 && !overLimit && !loading && !disabled;

  const handleQueryChange = nextValueOrEvent => {
    const nextValue =
      typeof nextValueOrEvent === 'string'
        ? nextValueOrEvent
        : nextValueOrEvent?.target?.value || '';
    onChange(nextValue);
  };

  const handlePressEnter = event => {
    event.preventDefault();
    if (!isSearchEnabled) return;
    onSearchButtonClick(value);
  };

  const counterLabel = `${length}/${NLP_STAGE_ONE_MAX_QUERY_CHARS}`;

  return (
    <SearchRow>
      <Input
        data-testid='nlp-search-input'
        value={value}
        onChange={handleQueryChange}
        multiline
        autoSize={{ minRows: 1 }}
        placeholder={placeholder}
        maxLength={2000}
        disabled={isDisabled}
        onPressEnter={handlePressEnter}
        style={{ width: '100%', paddingRight: `${inputRightPadding}px` }}
      />
      <SearchControlsAnchor>
        {showCounter && (
          <Tooltip
            title={`Maximum ${NLP_STAGE_ONE_MAX_QUERY_CHARS} characters`}
          >
            <SearchCharacterCount
              data-testid='nlp-search-char-counter'
              $overLimit={overLimit}
            >
              {counterLabel}
            </SearchCharacterCount>
          </Tooltip>
        )}
        <SearchButtonInside
          data-testid='nlp-search-submit'
          type='primary'
          disabled={!isSearchEnabled}
          onClick={() => isSearchEnabled && onSearchButtonClick(value)}
          loading={loading}
          icon={
            <Icon
              icon='magnifyingGlassNormal'
              size='sm'
              color={isSearchEnabled && !loading ? '#fff' : colours.grey}
            />
          }
        >
          Search
        </SearchButtonInside>
      </SearchControlsAnchor>
    </SearchRow>
  );
};
